module.exports = __webpack_public_path__ + "img/receiver-copy-icon.97540c6d.png";